export enum DataImportEntityGroupEnum {
  PRODUCTS = 'products',
  PARTNERS = 'partners',
  PRICES = 'prices',
  STOCK = 'stock',
  PAYMENTS = 'payments',
  PARTNER_ACCOUNT = 'partnerAccount',
}
